module.exports = __webpack_public_path__ + "img/category-lmo.cd4c9c71.svg";